// Same prize split the backend uses (TournamentServiceImpl.prizeTable):
//   prize(rank) = pool * rank^(-a) / (1^(-a) + 2^(-a) + ... + winners^(-a))
// a (steepness): 0 = equal split, 0.75 = close to Evoplay's table, 1 = default (2nd gets half of 1st).
// Each prize is rounded down to the cent, so the total never goes over the pool.
export const DEFAULT_STEEPNESS = 1;

/** Returns [{ rank, prize }] for every winning rank, or [] when the inputs are not usable. */
export const prizeTable = (pool, winners, steepness) => {
  if (!(pool > 0) || !(winners > 0) || winners > 10000 || !(steepness >= 0)) {
    return [];
  }
  let weightSum = 0;
  for (let rank = 1; rank <= winners; rank++) {
    weightSum += Math.pow(rank, -steepness);
  }
  const rows = [];
  for (let rank = 1; rank <= winners; rank++) {
    const prize = (pool * Math.pow(rank, -steepness)) / weightSum;
    rows.push({ rank, prize: Math.floor(prize * 100) / 100 });
  }
  return rows;
};
